export const initialState = {
  loading: {},
  errors: {},
  init: {},
};
